import { Box, Stack, Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { useSelector } from "react-redux";
import { getDeepViewValuesEntry } from "../../deepViewFieldMap";
import { renderDeepViewText } from "../../renderDeepViewText";

interface Props {
  /** API key of the column the user clicked, e.g. "total_income_usd" */
  columnKey?: string;
}

const ManualAdjustment = ({ columnKey }: Props) => {
  const deepViewData = useSelector(
    (state: any) => state?.deepView?.deepViewData,
  );
  const stage5Text = getDeepViewValuesEntry(
    deepViewData,
    columnKey,
  )?.stage5_prefilled;

  if (!stage5Text) return null;

  return (
    <>
      <Box
        sx={{
          border: "1px solid #ED6C0280",
          borderRadius: "8px",
          backgroundColor: "#ED6C020A",
          p: 1,
          mt:1
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1} mb={1}>
          <EditIcon
            sx={{
              color: "#E65100",
              fontSize: 18,
            }}
          />

          <Typography
            sx={{
              color: "#E65100",
              fontSize: "14px",
              fontWeight: 500,
              textTransform: "uppercase",
              letterSpacing: "0.5px",
            }}
          >
            Manual Adjustment Applied
          </Typography>
        </Stack>

        <Typography
          sx={{
            color: "#E65100",
            fontSize: "14px",
            lineHeight: "20px",
          }}
        >
          {renderDeepViewText(stage5Text)}
        </Typography>
      </Box>
    </>
  );
};

export default ManualAdjustment;
